export default __webpack_public_path__ + "static/media/increase-learning.8d6ddda6.svg";